import { createContext, useContext } from 'react';
import type { WidgetPageType } from '../../types';

export type NavigationContextType = {
  currentPage: WidgetPageType;
  go: (to: WidgetPageType) => void;
  backToMainPage: () => void;
};

export const NavigationContext = createContext<
  NavigationContextType | undefined
>(undefined);

export function useNavigation(): NavigationContextType {
  const context = useContext(NavigationContext);

  if (!context) {
    throw new Error('useNavigation must be used within an NavigationProvider');
  }

  return context;
}
